import { Link } from "react-router-dom";
import { Card, PageHeader } from "../ui";

export function ContractorHelpPage() {
  return (
    <div className="max-w-3xl">
      <PageHeader
        title="Help — Contractors"
        subtitle="You've been invited to upload documents for a project at The Elm at Clark, 1122 N. Clark Street, Chicago. You don't need an account; the link in your email is your access."
      />
      <Card>
        <h2 className="text-ink-800 m-0 mb-2">How the magic link works</h2>
        <ul className="list-disc pl-5 text-ink-700 space-y-1">
          <li>Each link is bound to <strong>one project</strong> and <strong>one contractor company</strong>. Single-use; opening it exchanges the link for a working session.</li>
          <li>Links expire <strong>14 days</strong> after issuance. If yours has expired, ask the unit owner to issue a new one.</li>
          <li>Don't forward the email — the link is bound to the receiving IP after first use.</li>
          <li>Lost the link? Ask the owner to reissue it. Property Management will not chase paperwork on your behalf.</li>
        </ul>
      </Card>
      <Card>
        <h2 className="text-ink-800 m-0 mb-2">What to upload</h2>
        <ul className="list-disc pl-5 text-ink-700 space-y-1">
          <li>Business license (City of Chicago)</li>
          <li>Certificate of Insurance (General Liability, Workers Comp, Auto Liability)</li>
          <li><strong>Plumbers:</strong> company plumbing license + individual plumber's license</li>
          <li><strong>Electricians:</strong> company license + individual electrician's license</li>
          <li>Permission to Enter form</li>
          <li>Construction Rules &amp; Regulations Acknowledgement (signed)</li>
          <li>Procedures for Unit Construction Inspection Acknowledgement (signed)</li>
        </ul>
        <p className="text-xs text-ink-500 mt-2">PDF or image up to 25 MB each. Each upload is virus-scanned.</p>
      </Card>
      <Card>
        <h2 className="text-ink-800 m-0 mb-2">Insurance requirements</h2>
        <ul className="list-disc pl-5 text-ink-700 space-y-1">
          <li><strong>General Liability:</strong> $1M each person / $1M each occurrence (BI), $1M each occurrence / $1M aggregate (PD)</li>
          <li><strong>Auto Liability:</strong> same numbers; owned, non-owned, and hired vehicles</li>
          <li><strong>Workers Comp:</strong> statutory limits</li>
          <li>Carrier rated at least <em>"A"</em> policyholder, <em>Class 10</em> financial per Best's</li>
          <li>30 days cancellation notice to each named party</li>
          <li><strong>Additional Insureds:</strong> The Elm at Clark Condominium Association, the Board, and Sudler Property Management</li>
        </ul>
      </Card>
      <Card>
        <h2 className="text-ink-800 m-0 mb-2">Building rules</h2>
        <ul className="list-disc pl-5 text-ink-700 space-y-1">
          <li><strong>Hours:</strong> 9 AM – 5 PM, Mon–Fri.</li>
          <li>Building entry: not before 7:30 AM. Loading dock only — no lobby or amenities.</li>
          <li>Daily trade ID at check-in.</li>
          <li>Chicago-licensed plumbers only. Riser/waste/vent relocation prohibited.</li>
          <li><strong>Ventless dryers only.</strong></li>
        </ul>
      </Card>
      <p className="text-xs text-ink-500 mt-4">
        Looking for the project owner's view?{" "}
        <Link to="/help" className="text-brand-700 hover:text-brand-800">
          General help
        </Link>
        .
      </p>
    </div>
  );
}
